import React from "react";
import { Modal } from "antd";
import { X, AlertCircle } from "lucide-react";
import "./ReconciliationNotification.css";

const ReconciliationNotification = ({ data, show, onClose }) => {
  if (!show || !data) return null;


  const { added = [], modified = [], deleted = [] } = data?.positions || {};

  const hasChanges = (added?.length > 0) || (modified?.length > 0) || (deleted?.length > 0);

  const renderPositionList = (positions, type) => {
    if (!positions || positions.length === 0) return null;

    const labels = {
      added: { text: "Positions Added", class: "reconciliation-added" },
      modified: { text: "Positions Modified", class: "reconciliation-modified" },
      deleted: { text: "Positions Removed", class: "reconciliation-deleted" }
    };

    return (
      <div className="reconciliation-change-group">
        <h6 className={`reconciliation-change-label ${labels[type].class}`}>
          {labels[type].text} ({positions.length})
        </h6>
        <div className="reconciliation-change-list">
          {positions.map((pos, idx) => (
            <div key={idx} className="reconciliation-change-item">
              <div className="reconciliation-item-main">
                <span className="reconciliation-symbol">{pos.tradingSymbol || pos.symbol || "Unknown"}</span>
                <span className="reconciliation-change-qty">Qty: {pos.netQuantity ?? pos.quantity ?? 0}</span>
              </div>
              
              {pos.impactedBaskets?.length > 0 && (
                <div className="reconciliation-impacted-baskets">
                  <span className="reconciliation-impacted-label">Affected Baskets:</span>
                  <div className="reconciliation-impacted-list">
                    {pos.impactedBaskets.map((basket, bIdx) => (
                      <span key={basket.id || bIdx} className="reconciliation-impacted-tag">
                        {basket.name}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Modal
      open={show}
      title="Position Reconciliation"
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      className="reconciliation-notification-modal"
      closeIcon={<X size={18} />}
    >
      <div className="reconciliation-notification-content">
        {hasChanges ? (
          <div className="reconciliation-notification-changes">
            {renderPositionList(added, "added")}
            {renderPositionList(modified, "modified")}
            {renderPositionList(deleted, "deleted")}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            <p style={{ color: '#9da9bb' }}>No position changes detected.</p>
          </div>
        )}

        <p className="reconciliation-notification-note">
          This is an informational notification. Position data has been updated automatically.
        </p>
      </div>
    </Modal>
  );
};

export default ReconciliationNotification;

